import Image from '../../../atoms/Image';

interface IMobileNavItemProps {
  icon: string;
  alt: string;
  onClick(): void;
}

const MobileNavItem = ({ icon, alt, onClick }: IMobileNavItemProps) => (
  <div className='global_header_mobile__block' onClick={onClick}>
    <Image size='m' src={icon} alt={alt} />
  </div>
);

export default MobileNavItem;
